import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

interface StableDatePickerProps {
  onChange?: (dates: [Dayjs, Dayjs] | null, dateStrings: [string, string]) => void;
  value?: [Dayjs, Dayjs] | null;
  defaultValue?: [Dayjs, Dayjs];
  format?: string;
  allowClear?: boolean;
  placeholder?: [string, string];
  style?: React.CSSProperties;
  className?: string;
}

const StableDatePicker: React.FC<StableDatePickerProps> = ({
  onChange,
  value,
  defaultValue,
  format,
  allowClear,
  placeholder,
  style,
  className,
  ...props
}) => {
  // Wrapper để đảm bảo onChange behavior ổn định
  const handleChange = (dates: [Dayjs | null, Dayjs | null] | null, dateStrings: [string, string]) => {
    if (onChange) {
      // Debounce để tránh multiple calls
      setTimeout(() => {
        onChange(dates as [Dayjs, Dayjs] | null, dateStrings);
      }, 0);
    }
  };

  return (
    <RangePicker
      value={value}
      defaultValue={defaultValue}
      onChange={handleChange}
      format={format}
      allowClear={allowClear}
      placeholder={placeholder}
      className={className}
      // Đảm bảo không có animation gây xung đột
      style={{
        ...style,
        animation: 'none',
        transition: 'all 0.2s ease'
      }}
      {...props}
    />
  );
};

export default StableDatePicker;
